import React from 'react';
import ToolHistoryCard from './ToolHistoryCard';

export default function ToolHistoryRow(props) {
  return <ToolHistoryCard {...props} compact />;
}
